<template>
  <div>
    <b-table
      :busy="loading"
      hover
      :items="this.scenarios.data"
      :fields="this.fields"
      @row-dblclicked="ver"
      show-empty
    >
      <!--Sub-Scenarios -->
      <template #cell(sub_scenarios)="data">
        <PopoverCell :row="data"></PopoverCell>
      </template>

      <!-- Posiciones -->
      <template #cell(position)="data">
        <PopoverCell :row="data"></PopoverCell>
      </template>

      <!-- VerRegistro -->
      <template #cell(line_deal)="data">
        <VerRegistro
          :row="data"
          :opcionVer="opcionVer"
          @ver="$emit('ver', data.item)"
        >
          {{ data.value }}
        </VerRegistro>
      </template>

      <template #table-busy>
        <div class="text-center my-2 mb-3">
          <OverlayButton clase="overlay-md"></OverlayButton>
        </div>
      </template>
    </b-table>

    <Pagination
      :data="this.scenarios"
      :limit="limit"
      @pagination-change-page="eventoPaginar"
    >
      <template #prev-nav>
        <span>&lt;</span>
      </template>
      <template #next-nav>
        <span>&gt;</span>
      </template>
    </Pagination>
  </div>
</template>

<script>
import { mapState } from "vuex";
import OverlayButton from "@/components/core/overlay/overlay-button.vue";
import PopoverCell from "@/components/datatables/PopoverCell.vue";
import Pagination from "laravel-vue-pagination";
import VerRegistro from "../../../../components/datatables/VerRegistro.vue";
export default {
  name: "scenario-datatable",
  components: { OverlayButton, PopoverCell, Pagination, VerRegistro },
  emits: ["paginar", "ver"],
  data() {
    return {
      limit: 10,
      fields: [
        {
          label: "Escenario",
          key: "name",
          sortable: true,
        },
        {
          label: "Sub-Escenarios",
          key: "sub_scenarios",
          formatter: "names_sub_scenarios",
          sortable: true,
        },
        {
          label: "Cargos asociados",
          key: "position",
          formatter: "filtrarDatosPosition",
          sortable: true,
        },
        {
          label: "Línea de Negocio",
          key: "line_deal",
          formatter: "line_deal_name",
          sortable: true,
        },
      ],
    };
  },
  props: {
    parametros: { type: Object, default: null },
    scenarios: { type: Object, default: null },
    opcionVer: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    ...mapState("modScenarios", [
      "scenario",
      //"scenarios",
      "scenarioselected",
      "loading",
      "loadingLineDeals",
      "lineDeals",
      "error",
      "message",
      "history",
    ]),
  },
  methods: {
    ver(item /*, index, event*/) {
      this.$emit("ver", item);
    },
    eventoPaginar(page = 1) {
      this.$emit("paginar", page);
    },
    line_deal_name(itvalue, key, item) {
      return item.line_deal.name;
    },
    filtrarDatosPosition(value, key, item) {
      let data = item.sub_scenarios.filter(
        (sub_scenario) => sub_scenario.position_sub_scenario.length > 0
      );
      data = data
        .map(function (sub_scenario) {
          return sub_scenario.position_sub_scenario
            .map(function (position_sub_scenario) {
              if (position_sub_scenario.position.name) {
                return position_sub_scenario.position.name;
              }
            })
            .join(", ");
        })
        .join(", ");
      return data;
    },
    names_sub_scenarios(value) {
      return value
        .map(function (sub_scenario) {
          return sub_scenario.name;
        })
        .join(", ");
    },
  },
};
</script>

<style lang="scss" scoped>
</style>